import React from "react";
import { Row, Col, Form, Radio, Input, Image } from "antd";
import "./Steps.scss";
import {
  AlertInfo,
  seccionElectoral,
  AlertForeig,
} from "../../../../utils/Validations/functions";
import { radioButton, observaciones } from "../../../../utils/rules";
import TableSolSimilares from "../TableSolSimilares";

export default function Credential(props) {
  const { form, changeRadio, datos } = props;
  const { user, disabled, alert, solSimilares } = props;
  //Destructiring de las propiedades de user
  const { claveElector, seccion } = user;

  //Se carga la imagen
  let images = [{ src: [] }];
  if(user&&user.docs!==null){
     //Almacenamiento de imagenes
     images = { src: user.docs !== null ? user.docs[0].imagen : [] };
     console.log('PASO 4', images);
  }
  const SIN_SECCION =
    "Sin sección electoral, la solicitud es de un mexicano residente en el extranjero.";

  return (
    <Form form={form} layout="vertical">
      <Row gutter={24}>
        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
          <h4>Credencial de elector (frente)</h4>
          <Col span={24} className="containerCred">
            <Image
                  src={images.src}
                  width={400}
                  placeholder={
                    <Image
                      src={images.src}
                      width={100}
                      className="preview_ant-image-mask"
                    />
                  }
              />
          </Col>
        </Col>
        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
          <h4>Datos capturados</h4>
          <div className="data">
            <div className="alert">
              {user.tipoObservador === 1 && (
                <>
                  <AlertForeig text={SIN_SECCION} />
                  <br />
                </>
              )}
              <AlertInfo disable={alert.clave} />
            </div>
            <Col span={24}>
              <Form.Item label="Clave de elector">{claveElector}</Form.Item>
            </Col>
            <Col span={24}>
            {user.tipoObservador === 0 && (
              <Form.Item label="Sección electoral">
                {seccionElectoral(seccion)}
            </Form.Item>
            )}
            </Col>

            <Col span={24}>
              <Form.Item 
                  label="¿Los datos coinciden con la credencial de elector?"
                  name="clave"
                  rules={ radioButton }
                  initialValue={ datos.clave }
              >
                  <Radio.Group
                    onChange={changeRadio("clave")}
                    disabled={disabled.clave}
                  >
                    <Radio value={true}>Sí</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={24}>
              {datos.clave !== undefined && !datos.clave &&
                <Form.Item 
                    label="Observaciones"
                    name="claveObs"
                    rules={ observaciones }
                    initialValue={ datos.claveObs }
                >
                    <Input.TextArea
                      onChange={changeRadio("claveObs")}
                      disabled={disabled.claveObs}
                      maxLength={150}
                    />
                </Form.Item>
              }
            </Col>
          </div>
        </Col>
      </Row>
      {solSimilares.dataSource && solSimilares.dataSource.length > 0 && (
        <>
        <Row className="top25px">
          <Col span={24}>
            <h4>Se encontraron los siguientes registros similares:</h4>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {/* Reutilizamos el AlertForeig para mostrar el Alert  */}
            <AlertForeig text="Puedes eliminar los registros similares desde el módulo de Registro de ciudadanía." />
            <br/>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <TableSolSimilares data={solSimilares.dataSource} loading={solSimilares.loading} />
          </Col>
        </Row>
        </>
      )}
    </Form>
  );
}
